import { render, staticRenderFns } from "./MonitTrackPage.vue?vue&type=template&id=60752e36&"
import script from "./MonitTrackPage.vue?vue&type=script&lang=js&"
export * from "./MonitTrackPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports